import { render, staticRenderFns } from "./PatientPhone.vue?vue&type=template&id=cd65bcc8"
import script from "./PatientPhone.vue?vue&type=script&lang=js"
export * from "./PatientPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports